import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { typography, colors } from '../../styles';
import Carousel from '../../components/Carousel';
import ContactModal from '../../components/ContactModal';

const styles = css`
padding: 0;
  .Overview_inner {
    @media (min-width: 992px) {
      width: 100%;
      display: flex;
    }
  }

  .Overview_carousel {
    width: 100%;
    order:1;
    background-color: transparent;
    @media (min-width: 992px) {
      width: 65%;
    }
    @media (min-width: 1440px) {
      width: 65%;
    }
  }
  .Overview_contentWrapper {
    width: 100%;
    background-color: #F3F3F3;
    position: relative;
    @media (min-width: 992px) {
      width: 35%;
    }
    @media (min-width: 1440px) {
      width: 35%;
    }
  }
  .Overview_contentInner{
    padding: 30px 20px 20px;
    color: ${colors.color4};
    @media (min-width: 992px) {
      padding: 30px 40px;
    }
    @media (min-width: 1440px) {
    }
  }
  .Overview_addressWrapper {
    display: flex;
    justify-content: space-between;
    margin-bottom: 21px;
    @media (min-width: 768px) {
      margin-bottom: 18px;
    }
    @media (min-width: 1250px) {
      width: 90%;
    }
  }
  .Overview_address {
    font-size: 20px;
    font-weight: 700;
    font-family: ${typography.SansSerif};
    color: #212121;
    letter-spacing: 0;
    @media (min-width: 768px) {
      font-size: 22px;
    }
    @media (min-width: 992px) {
      font-size: 25px;
    }
  }
  .Overview_addressSm {
    font-family:${typography.SansSerif};
    display: block;
    font-size: 16px;
    letter-spacing: 1px;
    line-height: 31px;
    text-transform: uppercase;
    font-weight: 300;
  }
  .Overview_mapLink {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 11px;
    font-weight: bold;
    line-height: 1.4;
    color: black;
    margin-left: 25px;
  }
  .Overview_mapLinkIcon {
    width: 15px;
    height: auto;
    margin-bottom: 1px;
  }
  .Overview_commPlan {
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.038667em;
    line-height: 1.35;
    &:not(:last-child) {
      margin-bottom: 0.2em;
    }
    @media (min-width: 992px) {
      font-size: 15px;
    }
  }
  .Overview_gridWrapper {
    margin: 20px 0 20px;
    border-top: solid 1px #E0E0E0;
    border-bottom: solid 1px #E0E0E0;
    @media (min-width: 1250px) {
    }
  }
  .Overview_grid {
    margin: 0 -8px -5px 0;
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.041429em;
    line-height: 1;
    text-transform: uppercase;
    color: #484941;
    padding: 10px 0;
    @media (min-width: 768px) {
      padding: 15px 0;
    }
  }
  .Overview_gridItem {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 145px;
    text-align: center;
    padding: 0 10px;
    margin: 10px 0;
    @media (min-width: 480px) {
    }
    @media (min-width: 992px) and (max-width: 1439.98px) {
    }
    h3{
      font-weight: 300;
      font-size: 24px;
    }
    .Overview_gridTitle{
      font-weight: bold;
      letter-spacing: 1.83px;
      text-transform: uppercase;
    }
  }
  .Overview_price {
    font-size: 19px;
    font-weight: bold;
    letter-spacing: 0.18px;
    line-height: 26px;
    color: #434241;
  }
  .Overview_status {
    font-size: 17px;
    letter-spacing: 0.005882em;
    line-height: 1.35;
  }
  .Overview_mortCalcIcon {
    margin-right: 12px;
  }
  .Overview_detailCTA {
    margin-top: 23px;
    @media (min-width: 992px) {
      margin-top: 30px;
    }
    @media (min-width: 1250px) {
      margin-top: 40px;
    }
  }
  @media (min-width: 768px) and (max-width: 991.98px) {
    .Overview_inner::after {
      content: '';
      display: table;
      clear: both;
    }
    .Overview_price,
    .Overview_status,
    .MortgageCalculatorWrapper {
      float: left;
    }
    .Overview_status,
    .MortgageCalculatorWrapper {
      clear: left;
    }
    .MCM_triggerButton {
      margin-top: 12px;
    }
    .Overview_detailCTA {
      float: right;
    }
    /* if there's no status… */
    .Overview_price ~ .Overview_detailCTA {
      margin-top: -22px;
    }
    /* if there is a status… */
    .Overview_price + .Overview_status ~ .Overview_detailCTA {
      margin-top: -43px;
    }
  }
  .Overview_detailsWrapper{
    p{color:${colors.color4};}
  }
  .Overview_scheduleBtn{
    margin: 15px 0;
    @media(min-width: 768px){
      width: 60%;
    }
  }
  .Overview_descriptionWrapper{
  }
  .Underdog_left{
    margin: 0 0 15px;
    padding: 0 0 15px;
  }
  .Overview_cta{
    background-color: white;
    position: relative;
    padding: 20px 25px;
    @media(min-width: 768px){
      padding: 30px;
    }
  }
  .Overview_ctaTitle{
    text-transform: uppercase;
    font-weight: bold;
    font-size: 20px;
    letter-spacing: .85px;
    @media(min-width: 768px){
      font-size: 42px;
      letter-spacing: 1.85px;
    }
  }
  .Overview_ctaPhone{
    font-weight: bold;
    color: #444444;
    font-size: 12px;
    @media(min-width: 768px){
      font-size: 22px;
      letter-spacing: 0.1px;
    }
  }
`;

const videoLightBoxStyle = css`
  position: relative;
  width: 80%;
  padding-top: calc(80% * 0.5625);
  margin-top: -22%;
  top: 50%;
  margin-left: 10%;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;


function HomeOverview({ agent, community, home, widget, builder }) {
  const carouselSlides = [
    ...get(home, 'photos', []),
    ...get(home, 'elevationPhotos', []),
  ];

  if (get(home, 'tourUrl')) {
    carouselSlides.splice(1, 0, {
      type: 'tour',
      element: (<div className={`Carousel_imageElement ${videoLightBoxStyle}`}><iframe title="Virtual Tour" src={get(home, 'tourUrl')} /></div>),
    });
  }

  const homeStreetAddress = get(home, 'address.streetAddress');
  const homePrice = get(home, 'price');
  const homeStatus = get(home, 'status');
  const approvedBuilder = widget.builder.filter(item => item._id === home.custom_builder);
  return (
    <div className={styles}>
      <div className="Overview_inner">
        <Carousel
          typeLabel="Photos"
          className="Overview_carousel"
          items={carouselSlides}
          mainImageProps={{
            width: 2000,
            height: 1125,
            exact: true,
          }}
          thumbnailImageProps={{
            width: 600,
            height: 400,
            exact: true,
          }}
        />
        <div className="Overview_contentWrapper d-flex flex-column">
          <div className="Overview_contentInner">
            <div className="Overview_addressWrapper">
              <h1 className="Overview_address">{homeStreetAddress}
                <span className="Overview_addressSm Underdog_left">
                  {`${get(home, 'address.addressLocality')}, ${get(home, 'address.addressRegion')}`}
                </span>
              </h1>
            </div>
            <div className="Overview_detailsWrapper row">
              <div className="col-12 col-md-8 d-flex flex-column">
                {
                  approvedBuilder.length > 0 &&
                  <div className="Overview_status"><strong>BUILDER:</strong> {approvedBuilder[0].name}</div>
                }
                {
                  get(community, 'name') &&
                  <div className="Overview_status">
                    <strong>NEIGHBORHOOD:</strong><Link
                      className="Overview_commPlanLink"
                      name="community-detail"
                      community={community}
                    > {get(community, 'name')}</Link>
                  </div>
                }
                {
                  homeStatus &&
                  <div className="Overview_status"><strong>STATUS:</strong> {homeStatus === 'Active' ? 'Available Now' : homeStatus}</div>
                }
              </div>
              <div className="col-12 col-md-4 d-flex align-items-center">{
                (homePrice || homeStatus !== 'Sold') &&
                <div className="Overview_price">
                  {
                    homePrice &&
                    numeral(homePrice).format('$0,0')
                  }
                  {
                    !homePrice &&
                    'Call for pricing'
                  }
                </div>
              }</div>
            </div>
            <div className="Overview_gridWrapper">
              <ul className="Overview_grid list-unstyled">
                {
                  get(home, 'beds', '') &&
                  <li className="Overview_gridItem">
                    <h3>{home.beds}</h3>
                    <p className="Overview_gridTitle mb-1">Beds</p>
                  </li>
                }
                {
                  get(home, 'bathsFull', '') &&
                  <li className="Overview_gridItem">
                    <h3>{home.bathsFull}{get(home, 'bathsHalf') ? '.5' : ''}</h3>
                    <p className="Overview_gridTitle mb-1">Baths</p>
                  </li>
                }
                {
                  get(home, 'sqft') &&
                  <li className="Overview_gridItem">
                    <h3>{numeral(get(home, 'sqft')).format('0,0')}</h3>
                    <p className="Overview_gridTitle mb-1">SQ FT</p>
                  </li>
                }
                {
                  get(home, 'garages') &&
                  <li className="Overview_gridItem">
                    <h3>{`${home.garages}-Car`}</h3>
                    <p className="Overview_gridTitle mb-1">Garage</p>
                  </li>
                }
                {
                  get(home, 'stories') &&
                  <li className="Overview_gridItem">
                    <h3>{home.stories}</h3>
                    <p className="Overview_gridTitle mb-1">Stor{home.stories > 1 ? 'ies' : 'y'}</p>
                  </li>
                }
                {
                  get(home, 'lot') &&
                  <li className="Overview_gridItem">
                    <h3>{home.lot}</h3>
                    <p className="Overview_gridTitle mb-1">Lot</p>
                  </li>
                }
              </ul>
            </div>
            {get(home, 'headline') &&
            <div className="Overview_descriptionWrapper">
              <div dangerouslySetInnerHTML={SanitizeHtml(get(home, 'headline'))} />
            </div>
            }
            <ContactModal agent={agent}>
              <div className="Btn Gold Overview_scheduleBtn">Schedule A Visit</div>
            </ContactModal>
          </div>
          <div className="Overview_cta mt-auto w-100">
            <h3 className="Overview_ctaTitle GoldText">Have Questions?</h3>
            <h4 className="Overview_ctaPhone">Call <a href={`tel:${approvedBuilder.length > 0 ? approvedBuilder[0].phone_number : builder.telephone}`}>
              {(approvedBuilder.length > 0 && approvedBuilder[0].phone_number)
                ? approvedBuilder[0].phone_number
                : agent.telephone || builder.telephone}
            </a></h4>
          </div>
        </div>
      </div>
    </div>
  );
}

HomeOverview.propTypes = {
  community: PropTypes.object,
  home: PropTypes.object.isRequired,
  agent: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
  builder: PropTypes.object.isRequired,
};

HomeOverview.defaultProps = {
  community: undefined,
};


export default withData(
  {
    builder: true,
    home: true,
    widget: 'approved_builders',
  },
  {
    required: {
      home: true,
    },
  },
)(HomeOverview);



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/Overview.js